
<div *ngIf="isLoading">
    <app-loading-spinner></app-loading-spinner>
  </div>
  
  <!-- Default form register -->
  <div class="col-md-12">
  
  
  <form *ngIf="!isLoading" #form="ngForm"  [formGroup]="validatingForm" class="text-center border border-light p-5">
  
      <p class="h4 mb-4">Add Post</p>
  
  
     <!-- book title -->
  
      <input type="text" id="title" mdbInput mdbValidate  #title formControlName="title" class="form-control mb-4" placeholder="Enter Post title " aria-describedby="title" name="title">
     <!-- Book  Description -->
      <textarea type="text" id="Description" #description formControlName="description" mdbValidate class="form-control mb-4 md-textarea  " placeholder="Enter Post Content " aria-describedby="Description"></textarea>
  
  
     <!-- Phone number -->
      <input type="text" id="Image" formControlName="image" mdbInput mdbValidate class="form-control mb-4" placeholder="Enter book Image " aria-describedby="Image">

      <!-- Sign up button -->
      <button mdbBtn color="danger" [disabled] = "!form.valid" block="true" class="my-4" type="submit" (click)="on(form)">Add book</button>
  
    </form>
    <!-- Default form register -->
  
  </div>
  